import { StylesConfig } from 'react-select'
import { Theme } from 'styles/Themes'

interface SelectStylesProps {
  searchbar?: boolean
  width?: number
  error?: boolean
  small?: boolean
  large?: boolean
}

export const selectStyles = ({
  searchbar,
  error,
  small,
  large,
  width,
}: SelectStylesProps & { width?: number }): StylesConfig<any, boolean> => {
  let controlWidth = '100%' // default

  if (small) controlWidth = '155px'
  else if (large) controlWidth = '315px'
  else if (typeof width === 'number') controlWidth = `${width}px`
  return {
    container: (base) => ({
      ...base,
      marginLeft: '0.5px',
      width: `312px`,
      maxWidth: '100%',
      minWidth: 'fit-content',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }),
    control: (base, props) => ({
      ...base,
      background: props.isDisabled
        ? Theme.pallete.QUATERNARY
        : Theme.pallete.SECONDARY,

      width: controlWidth,
      borderWidth: 1,
      borderRadius: 5,
      paddingLeft: '14.5px',
      fontSize: '12px',
      fontWeight: 400,
      outline: 'none',
      height: '48px',
      boxShadow: 'none',
      borderColor: props.isDisabled
        ? 'transparent'
        : error
        ? '#D61212'
        : '#cccccc', // lógica condicional corrigida
      transition: 'all 0.3s ease-out',
      display: 'flex',
      alignItems: 'center',

      minWidth: 0, // ESSENCIAL!
      '&:hover': {
        borderColor: '#757575',
      },
      '&:focus': {
        borderColor: '#1C1D22',
      },
    }),
    valueContainer: (base) => ({
      ...base,
      paddingLeft: searchbar ? '10px' : '0',
      fontSize: 12,
      color: 'black',
      margin: 0,
      width: '100%',
      maxWidth: '100%x',
      minWidth: 0, // ESSENCIAL!
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      display: 'flex',
      alignItems: 'center',
    }),

    placeholder: (base) => ({
      ...base,
      display: 'none',
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      display: searchbar ? 'none' : 'block',
    }),

    option: (styles, props) => ({
      ...styles,
      padding: '12px 0 12px 18.5px',
      textOverflow: 'ellipsis',
      zIndex: 50,
      overflowX: 'hidden',
      fontSize: 12,
      fontFamily: 'Inter',
      whiteSpace: 'nowrap',
      textAlign: 'left',
      fontWeight: 400,
      transition: 'all 0.3s ease-out',
      backgroundColor: props.isSelected
        ? 'rgb(245, 245, 245)'
        : Theme.pallete.SECONDARY,
      color: props.isSelected ? '#424242' : '#424242',
      ':hover': {
        backgroundColor: 'rgb(245, 245, 245)',
      },
    }),
    indicatorSeparator: (base) => ({
      ...base,
      display: 'none',
    }),

    menu: (base) => ({
      ...base,
      width: '100%',
      zIndex: 40,
    }),
    menuList: (base) => ({
      ...base,
      zIndex: 40,
      width: '100%',
      '::-webkit-scrollbar': {
        width: '8px',
        backgroundColor: '#C4C4C4',
        borderRadius: '50px',
      },
      '::-webkit-scrollbar-track': {
        background: '#fbfbfb',
      },
      '::-webkit-scrollbar-thumb': {
        backgroundColor: '#C4C4C4',
        borderRadius: '50px',
      },
    }),
    singleValue: (base, props) => ({
      ...base,
      fontFamily: 'Inter',
      fontSize: '12px',
      fontWeight: 400,
      paddingLeft: '3px', // Adiciona o padding apenas ao texto
      marginLeft: 0,
      transition: 'all 0.3s ease-out',
      color: props.isDisabled ? 'rgb(84, 84, 84)' : base.color,
    }),
  }
}
